import React, { useState } from "react";
import "./tooltip.css";


const Tooltip = (props) => {
    let timeout;
    const [active, setActive] = useState(false);

    const showTip = () => {
        timeout = setTimeout(() => {
            setActive(true);
        }, props.delay || 400);
    };

    const hideTip = () => {
        clearInterval(timeout);
        setActive(false);
    };

    return (
        <div
            className="Tooltip-Wrapper"
            // When to show the tooltip
            onMouseEnter={showTip}
            onMouseLeave={hideTip}
        >
            {/* Wrapping */}
            {props.children}
            {active && (
                <div
                    style={{ width: props.width || '400px', height: props.height || '150px' }}
                    className={`Tooltip-Tip ${props.direction || "top"}`}>
                    <div className={"Label"} >
                        <div className={"Title"}>{props.title}</div>
                        <div className={"Content"}><p className={"P"}>{props.content}</p></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Tooltip;
